import { useState, useEffect } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseServices from "Hooks/UseServices";

import * as S from "../styles";
import NewPassword from "./Components/NewPassword";
import Verification from "./Components/Verification";

const ForgotPassword = ({ email, loading, setLoading, setLoginStep }) => {
  const { api } = UseServices();
  const [forgotPasswordStep, setForgotPasswordStep] =
    useState("verificationCode");
  const [userId, setUserId] = useState(null);
  const [code, setCode] = useState(null);

  useEffect(() => {
    getVerificationCode();
    //eslint-disable-next-line
  }, []);

  const getVerificationCode = () => {
    setLoading(true);

    api
      .post("/request-password-code", { login: email })
      .then(() => {
        setLoading(false);
        setForgotPasswordStep("verificationCode");
      })
      .catch((error) => {
        HTTPErrorCallback(error);
        setLoginStep("password");
        setLoading(false);
      });
  };

  const getComponent = () => {
    switch (forgotPasswordStep) {
      case "newPassword":
        return (
          <NewPassword
            loading={loading}
            setLoading={setLoading}
            setLoginStep={setLoginStep}
            userId={userId}
            code={code}
          />
        );
      case "verificationCode":
      default:
        return (
          <Verification
            loading={loading}
            setForgotPasswordStep={setForgotPasswordStep}
            setVerificationCode={setCode}
            setUserId={setUserId}
            setLoading={setLoading}
            getVerificationCode={getVerificationCode}
            email={email}
          />
        );
    }
  };

  return <S.Container>{getComponent()}</S.Container>;
};

export default ForgotPassword;
